import React, { useContext, useState } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { Button, Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import ReAttempt from '../../components/ReAttempt/ReAttempt';
const Fail = () => {
  const [showReattempt, setShowReattempt] = useState<boolean>(false);
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const handleReAttempt = () => {
    setShowReattempt(!showReattempt);
  };
  return <article data-sentry-component="Fail" data-sentry-source-file="Fail.tsx">
      <div className="flex flex-wrap justify-between gap-2">
        <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="Fail.tsx">
          Fast Track Process Video Interview Result
        </Typography>
      </div>
      <div className="relative p-5 border border-[#FEC8C8] bg-[#FFFBFA] rounded-lg flex gap-2 text-center items-center my-4">
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/7fc697aa-79f3-43ba-85bc-818acc5d6653.svg" alt="heart-broken" width={120} height={120} className="absolute bottom-0 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Fail.tsx" />
        <div className="z-10 flex flex-col items-center self-center gap-3 mx-auto text-center py-2">
          <Typography variant="heading3" weight="semi-bold" className="!text-sm sm:!text-lg" data-sentry-element="Typography" data-sentry-source-file="Fail.tsx">
            Unfortunately, You Did Not Clear the Video Interview This Time
          </Typography>
          {registrationDetails?.retryCount === 1 ? <Typography variant="regular" className="!text-sm !text-[#757575] max-w-[360px]">
              Don't worry — this isn't the end of the road. You can still re-attempt and secure your
              spot at PW IOI.
            </Typography> : null}
          {registrationDetails?.retryCount === 1 ? <div className="flex items-center gap-1 mt-2">
              <Typography variant="regular" weight="semi-bold" className="!text-sm">
                Want to give it another shot?
              </Typography>
              <Button size="small" variant="lowFocus" onClick={handleReAttempt} className="!text-[#196CDC]">
                Re-attempt
              </Button>
            </div> : null}
        </div>
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/7fc697aa-79f3-43ba-85bc-818acc5d6653.svg" alt="heart-broken" width={120} height={120} className="absolute bottom-0 right-4 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Fail.tsx" />
      </div>

      {showReattempt ? <ReAttempt onClose={handleReAttempt} /> : null}
    </article>;
};
export default Fail;